var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBikerOptimized = function SvgBikerOptimized(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 346.15 304.91",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-44.766 -.0040282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "man-bike"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "m260.62 98.451s7.017 14.984 10.372 18.509c3.354 3.525 52.896 25.843 52.896 25.843s1.925 2.356 5.571 0.934c3.647-1.421 7.554-10.81 7.554-10.81s-2.746-3.963-6.092-4.134c-3.346-0.17-1.462-2.777-1.462-2.777l-5.904 2.777s-3.574 1.836-12.946-5.084c-9.372-6.919-28.353-15.829-28.353-15.829l-4.061-11.541z",
    fill: "url(#paint0_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m260.62 98.451s7.017 14.984 10.372 18.509c3.354 3.525 52.896 25.843 52.896 25.843s1.925 2.356 5.571 0.934c3.647-1.421 7.554-10.81 7.554-10.81s-2.746-3.963-6.092-4.134c-3.346-0.17-1.462-2.777-1.462-2.777l-5.904 2.777s-3.574 1.836-12.946-5.084c-9.372-6.919-28.353-15.829-28.353-15.829l-4.061-11.541z",
    fill: "url(#paint1_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m276.27 62.992 3.11 28.808v5.7176h-4.735l-7.236-12.848z",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m276.27 62.992 3.11 28.808v5.7176h-4.735l-7.236-12.848z",
    fill: "url(#paint2_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m246.6 262.16c10.335 0 18.713-8.468 18.713-18.915s-8.378-18.915-18.713-18.915c-10.334 0-18.712 8.468-18.712 18.915s8.378 18.915 18.712 18.915z",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m246.6 262.16c10.335 0 18.713-8.468 18.713-18.915s-8.378-18.915-18.713-18.915c-10.334 0-18.712 8.468-18.712 18.915s8.378 18.915 18.712 18.915z",
    fill: "url(#paint3_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m335.62 253.87c-0.37 0.298-0.819 0.482-1.292 0.528-27.8-9.957-33.299-80.762-33.299-80.762l6.831-1.454c0 0.179 0 0.366 0.049 0.544 4.629 58.598 27.962 80.283 27.962 80.283 0.03 0.153 0.023 0.311-0.021 0.461-0.043 0.15-0.123 0.287-0.23 0.4z",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m335.62 253.87c-26.648-11.679-31.967-80.201-31.967-80.201l4.272-0.91c4.629 58.598 27.963 80.283 27.963 80.283 0.022 0.149 0.01 0.302-0.037 0.445-0.046 0.144-0.126 0.275-0.231 0.383z",
    fill: "url(#paint4_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.38 137.26 26.063 50.354 16.121-1.25 1.088-50.736s-39.373-32.016-43.272 1.632z",
    fill: "#25233a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m217.27 191.34-0.926-4.873-14.903 1.154 2.322 6.651-1.039 3.249c-1.989 6.232-2.394 12.861-1.178 19.289l21.734 43.857 7.797-0.512z",
    fill: "url(#paint5_linear_1_2)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#68e1fd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m190.34 160.33h6.896l-14.538 81.988c-0.136 0.786-0.546 1.498-1.157 2.011s-1.384 0.793-2.181 0.791h-0.057c-0.496-1e-3 -0.986-0.11-1.435-0.32s-0.847-0.516-1.166-0.896c-0.318-0.379-0.55-0.824-0.679-1.303s-0.151-0.98-0.066-1.469z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m190.34 175.54 108.86-27.029v8.162l-108.86 27.557z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.01 228.91 116.18-70.553v10.055l-116.18 69.692z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m183.01 228.91 116.18-70.553v10.055l-116.18 69.692z",
    fill: "url(#paint6_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m311.86 148.01v20.109c1e-3 1.106-0.387 2.177-1.095 3.026s-1.692 1.422-2.779 1.62l-3.249 0.593c-0.681 0.125-1.381 0.099-2.05-0.077-0.67-0.176-1.293-0.497-1.825-0.94-0.531-0.443-0.959-0.998-1.252-1.625s-0.445-1.311-0.444-2.004v-20.117c0-1.105 0.389-2.175 1.096-3.024 0.708-0.848 1.691-1.422 2.778-1.622l0.593-0.105 2.639-0.479c0.682-0.128 1.384-0.104 2.056 0.071 0.671 0.174 1.296 0.495 1.83 0.938 0.533 0.444 0.963 1 1.257 1.628 0.294 0.629 0.446 1.314 0.445 2.008z",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m311.86 146.71v22.31c0 0.853-0.299 1.678-0.845 2.333-0.546 0.654-1.305 1.096-2.144 1.249l-5.393 0.99c-0.525 0.096-1.064 0.074-1.58-0.062-0.515-0.136-0.995-0.383-1.405-0.725-0.409-0.341-0.739-0.769-0.966-1.251-0.226-0.483-0.344-1.01-0.345-1.543v-22.335c-1e-3 -0.852 0.299-1.678 0.845-2.333 0.546-0.654 1.305-1.096 2.144-1.248l1.478-0.277 3.914-0.714c0.527-0.097 1.069-0.076 1.587 0.06 0.519 0.137 1 0.387 1.411 0.731 0.41 0.345 0.739 0.776 0.964 1.262 0.224 0.487 0.339 1.017 0.335 1.553z",
    fill: "url(#paint7_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m316.33 171.14-4.467 0.812v-29.62l-8.211 1.503v-0.082l12.678-2.33",
    fill: "url(#paint8_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m311.86 142.33v29.62l-8.211 1.502v-29.619z",
    fill: "url(#paint9_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m190.34 175.55-95.38 59.288s-4.1502 10.599 0 10.274 87.714-2.802 87.714-2.802l0.309-9.137-82.622 7.594s-2.6716-1.625 1.113-4.662c3.785-3.038 88.867-51.881 88.867-51.881z",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m197.23 160.33-2.502 14.148-1.624 9.072-10.42 58.784c-0.136 0.786-0.546 1.499-1.157 2.011-0.611 0.513-1.384 0.793-2.181 0.791h-0.057c-0.763-1e-3 -1.503-0.259-2.101-0.732s-1.02-1.133-1.197-1.875c-0.115-0.451-0.131-0.922-0.048-1.381l1.324-7.423 8.316-46.748 1.698-9.519 3.045-17.112z",
    fill: "url(#paint10_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m299.18 148.52v8.154l-106.07 26.85 1.616-9.063z",
    fill: "url(#paint11_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.38 240.78 76.896-7.066-1.324 7.423c-0.081 0.479 0.422-3.46 0.536-3.021-19.914 0.601-77.326 3.249-81.103 5.133-3.7766 1.884 2.4365-8.195 2.4365-8.195l88.754-53.546-0.975 5.458c-17.948 10.322-80.867 46.537-84.099 49.152-3.7932 3.054-1.121 4.662-1.121 4.662z",
    fill: "url(#paint12_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m318.08 140.74-4.215 5.214s0.089 4.256 3.005 4.013l16.812-22.181s9.583-13.344 0.706-19.492c-1.998-1.373-4.295-2.25-6.7-2.558-11.882-1.584-22.432 7.781-22.919 19.752l-0.813 19.208 5.426-0.317 1.08-21.458c0.292-8.933 15.512-18.501 21.782-9.185 3.566 5.246-7.537 19.321-14.164 27.004z",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m266.81 47.317c4.004-3.5979 7.699-7.9998 8.593-13.311 0.373-2.2741 0.251-4.6456 0.544-6.9278 0.544-4.1989 1.299-8.812 4.556-11.525 1.615-1.2143 3.483-2.0473 5.466-2.4365 1.758-0.4654 3.576-0.6626 5.393-0.5848 5.799 0.3655 10.94 5.0598 12.182 10.729 0.362 2.0174 0.509 4.0673 0.439 6.1157v5.8232c-0.082 1.2871 0.086 2.5779 0.495 3.8009 0.439 1.0721 1.267 2.136 0.991 3.2487-0.349 0.841-0.965 1.5433-1.754 1.9979-0.979 0.7622-1.85 1.6528-2.591 2.6477-1.161 1.5675-2.014 3.403-3.541 4.6131-2.502 1.9898-6.067 1.7462-9.226 1.2751-1.36-0.2819-2.756-0.3423-4.134-0.1787-2.892 0.5279-5.028 3.0538-7.821 3.9634-0.374 0.1407-0.771 0.207-1.17 0.1949-1.104-0.0731-1.917-1.0071-2.607-1.868-1.835-2.3146-3.98-5.2872-5.815-7.5775z",
    fill: "url(#paint13_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m275.36 71.95c-1.401 4.9055-4.157 9.3165-7.951 12.727l-47 42.33c-3.295 2.971-7.157 5.244-11.355 6.682-4.197 1.438-8.642 2.01-13.067 1.683-0.276 0-0.561 0-0.812-0.073-12.8-1.283-27.89-6.766-23.927-26.063 6.636-32.316 72.283-59.377 72.283-59.377 21.319-8.9826 29.238-1.3644 31.926 8.0729 1.268 4.5914 1.234 9.4448-0.097 14.018z",
    fill: "#dff6fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m271.29 66.11-0.707 7.6587c-1.364 4.8161 0.707 7.4069-3.143 10.875l-47 42.33c-3.294 2.972-7.157 5.245-11.354 6.683-4.198 1.437-8.643 2.01-13.068 1.682l-9.794-4.337s5.579-18.387 37.254-42.614c31.674-24.227 47.812-22.278 47.812-22.278z",
    fill: "url(#paint14_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.92 260.21c-0.205-0.011-0.41 0.034-0.592 0.13-0.148 0.114-0.258 0.27-0.317 0.447-0.682 1.624-0.065 3.541 0.601 5.198 0.078 0.248 0.214 0.473 0.398 0.657 0.195 0.146 0.424 0.238 0.666 0.268 1.705 0.26 3.33-0.812 5.06-0.966 0.882 0.044 1.767 0.022 2.647-0.065 0.732-0.224 1.389-0.645 1.896-1.219 0.507-0.573 0.846-1.276 0.979-2.03 0.255-1.5 0.224-3.035-0.089-4.523-5e-3 -0.232-0.098-0.453-0.26-0.618-0.136-0.084-0.294-0.127-0.455-0.122-0.785-0.045-1.567 0.138-2.249 0.528-0.585 0.333-1.081 0.813-1.625 1.162-1.957 1.161-4.483 1.112-6.66 1.153z",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.92 260.21c-0.205-0.011-0.41 0.034-0.592 0.13-0.148 0.114-0.258 0.27-0.317 0.447-0.682 1.624-0.065 3.541 0.601 5.198 0.078 0.248 0.214 0.473 0.398 0.657 0.195 0.146 0.424 0.238 0.666 0.268 1.705 0.26 3.33-0.812 5.06-0.966 0.882 0.044 1.767 0.022 2.647-0.065 0.732-0.224 1.389-0.645 1.896-1.219 0.507-0.573 0.846-1.276 0.979-2.03 0.255-1.5 0.224-3.035-0.089-4.523-5e-3 -0.232-0.098-0.453-0.26-0.618-0.136-0.084-0.294-0.127-0.455-0.122-0.785-0.045-1.567 0.138-2.249 0.528-0.585 0.333-1.081 0.813-1.625 1.162-1.957 1.161-4.483 1.112-6.66 1.153z",
    fill: "url(#paint15_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m225.36 266.05c-0.628 0.198-1.203 0.537-1.681 0.99-1.04 1.089-0.959 2.786-0.739 4.272 0.251 1.747 0.592 3.479 1.023 5.19 0.227 0.893 0.593 1.917 1.47 2.209 0.451 0.11 0.922 0.11 1.373 0 7.754-1.35 15.399-3.272 22.87-5.75 0.298-0.062 0.567-0.222 0.764-0.455 0.158-0.296 0.193-0.644 0.097-0.966-0.975-5.052-5.831-4.719-9.787-5.344-5.092-0.812-10.42-2.014-15.39-0.146z",
    fill: "#25233a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m185.94 142.87s-15.057-3.013-13.644 5.352c1.413 8.366 2.518 10.088 6.773 11.371 17.949 5.206 36.897-6.075 36.897-6.075s1.535-11.176-30.026-10.648z",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m185.94 142.87s-15.057-3.013-13.644 5.352c1.413 8.366 2.518 10.088 6.773 11.371 17.949 5.206 36.897-6.075 36.897-6.075s1.535-11.176-30.026-10.648z",
    fill: "url(#paint16_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m287.98 31.017c-0.479 2.0548-0.658 4.272-1.868 5.9938l-1.486-3.8497c-0.08-0.3223-0.266-0.6084-0.528-0.8121-0.167-0.0747-0.349-0.1085-0.531-0.0986-0.182 0.0098-0.359 0.0632-0.517 0.1554-0.543 0.2916-0.998 0.7233-1.318 1.2503s-0.493 1.1301-0.501 1.7466c1e-3 1.2387 0.371 2.449 1.064 3.4761 0.228 0.3036 0.389 0.6525 0.471 1.0233 6e-3 0.3328-0.091 0.6592-0.277 0.9352s-0.452 0.4882-0.763 0.6079c-0.629 0.2251-1.299 0.3137-1.965 0.2599l-3.549-0.0487c-3.249-0.0487-6.928-0.2761-9.064-2.7289 0.487-0.7147 1.624-0.8121 2.095-1.4781 0.155-0.2604 0.237-0.5578 0.237-0.8609s-0.082-0.6006-0.237-0.8609c-0.323-0.5138-0.738-0.9628-1.226-1.3238l-2.307-1.8924c-0.601-0.5035-1.25-1.1695-1.088-1.9329 0.309-1.4538 3.119-1.3807 3.094-2.8589 0-0.7228-0.763-1.1695-1.388-1.535-0.626-0.3654-1.292-1.0152-1.04-1.6893 0.292-0.8121 1.462-0.6903 2.225-1.0883 0-0.9583-1.478-1.3076-1.624-2.2415-0.019-0.2602 0.04-0.5202 0.17-0.7462 0.131-0.2259 0.326-0.4074 0.561-0.5208 0.476-0.2108 0.99-0.3214 1.511-0.3249l3.557-0.2761c4.637-0.4908 9.307-0.5967 13.961-0.3168 0.921 0.0328 1.828 0.2395 2.672 0.6091 0.944 0.5189 1.734 1.2782 2.29 2.201 0.723 1.1533 0.423 1.4863-0.138 2.672-1.065 2.0886-1.9 4.2861-2.493 6.5542z",
    fill: "#25233a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m316.33 146.52-2.437-0.561s0.09 4.256 3.005 4.013l16.812-22.181s9.584-13.344 0.707-19.492c-1.999-1.373-4.296-2.25-6.701-2.558-11.882-1.584-22.432 7.781-22.919 19.752l-0.812 19.208 2.29-1.357 1.462-20.84c0.292-8.934 16.917-20.304 26.598-10.558 6.839 6.814-9.591 29.295-18.005 34.574z",
    fill: "url(#paint17_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240.53 264.99c-16.925 0-120.39-11.89-141.19-14.303-2.0475-0.219-3.9304-1.223-5.2537-2.801-1.3234-1.578-1.9845-3.607-1.8447-5.661 0.2518-2.778 2.0954-6.238 9.4863-6.928 1.299-0.122 129.71-12.045 142.22-13.393 6.611-0.706 12.694 1.08 17.121 5.028 2.064 1.898 3.702 4.211 4.807 6.789 1.104 2.577 1.65 5.359 1.601 8.163 0.073 15.163-8.544 22.74-26.355 23.098zm-138.68-28.077c-5.0439 0.471-7.7403 2.307-8.0246 5.458-0.1028 1.635 0.432 3.247 1.492 4.496 1.0601 1.249 2.563 2.039 4.1932 2.204 21.059 2.437 126.84 14.619 141.59 14.286 16.966-0.357 24.836-7.179 24.763-21.465 0.046-2.578-0.457-5.137-1.475-7.506s-2.528-4.495-4.43-6.236c-4.061-3.647-9.705-5.295-15.861-4.63-12.516 1.349-140.93 13.271-142.24 13.393z",
    fill: "#000",
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("path", {
    d: "m267.48 52.702c-2.001-0.1816-3.996 0.3985-5.588 1.6243-3.785 2.6964-5.758 7.2689-6.944 11.76-1.15 4.8816-1.94 9.841-2.363 14.838-0.561 5.1735-1.121 10.461 0 15.553 0.349 1.6243 0.982 3.3867 2.436 4.2317 1.722 1.015 3.899 0.381 5.791-0.268l12.012-4.1586c0.911-0.193 1.711-0.7316 2.233-1.5026 0.267-0.7202 0.287-1.5087 0.057-2.2415-1.34-6.4974-0.463-14.92 0.065-21.506 0.406-5.5309 1.568-17.064-7.699-18.331z",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.99 100.73s7.423 14.985 10.98 18.517c3.558 3.533 56.04 25.876 56.04 25.876s2.038 2.355 5.904 0.926 7.992-10.802 7.992-10.802-2.908-3.963-6.449-4.142-1.543-2.778-1.543-2.778l-6.262 2.778s-3.784 1.836-13.709-5.076-30.05-15.902-30.05-15.902l-5.109-13.807z",
    fill: "url(#paint18_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262.69 46.042 7.61-2.2334s5.271 9.6566 4.93 12.905z",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262.69 46.042 7.61-2.2334s5.271 9.6566 4.93 12.905z",
    fill: "url(#paint19_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m275.02 94.804-0.812 5.4658-17.186 4.532-3.646-5.7827s12.475-2.1278 21.644-4.2151z",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m275.02 94.804-0.812 5.4658-17.186 4.532-3.646-5.7827s12.475-2.1278 21.644-4.2151z",
    fill: "url(#paint20_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.24 130.03s0.09 18.834 20.11 22.083c20.019 3.248 60.165-5.044 60.165-5.044l9.332-17.908-45.539-11.85s-40.575-4.873-44.068 12.719z",
    fill: "#25233a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m259.85 129.16-9.332 17.908s9.746-2.258 10.769-0.317c1.024 1.941-8.065 5.945-9.112 32.568-0.114 2.94-1.909 14.676-2.437 17.576l-1.624 5.246s6.984 0.739 7.309 0.634c0.325-0.106 29.393-61.66 18.851-68.653-3.03-2.038-14.424-4.962-14.424-4.962z",
    fill: "url(#paint21_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m243.42 202.35c-1e-3 -0.54 0.12-1.074 0.353-1.562 0.234-0.488 0.574-0.917 0.995-1.256 0.357-0.191 0.749-0.308 1.152-0.344 0.403-0.037 0.81 9e-3 1.195 0.133 0.768 0.245 1.517 0.547 2.241 0.901 1.619 0.675 3.365 0.991 5.117 0.926 0.764 0 1.624-0.065 2.128 0.536 0.162 0.298 0.251 0.63 0.261 0.968 0.01 0.339-0.06 0.675-0.204 0.982-0.416 1.337-0.945 2.636-1.584 3.882-0.078 0.193-0.204 0.363-0.365 0.495-0.174 0.101-0.369 0.162-0.569 0.179-2.932 0.44-5.919 0.372-8.828-0.203-3.338-0.666-2.12-3.127-1.892-5.637z",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m231.21 257.91c-0.585 0.333-1.081 0.812-1.625 1.161z",
    fill: "url(#paint22_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m243.42 202.35c-1e-3 -0.54 0.12-1.074 0.353-1.562 0.234-0.488 0.574-0.917 0.995-1.256 0.357-0.191 0.749-0.308 1.152-0.344 0.403-0.037 0.81 9e-3 1.195 0.133 0.768 0.245 1.517 0.547 2.241 0.901 1.619 0.675 3.365 0.991 5.117 0.926 0.764 0 1.624-0.065 2.128 0.536 0.162 0.298 0.251 0.63 0.261 0.968 0.01 0.339-0.06 0.675-0.204 0.982-0.416 1.337-0.945 2.636-1.584 3.882-0.078 0.193-0.204 0.363-0.365 0.495-0.174 0.101-0.369 0.162-0.569 0.179-2.932 0.44-5.919 0.372-8.828-0.203-3.338-0.666-2.12-3.127-1.892-5.637z",
    fill: "url(#paint23_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m243.66 207.04c1.535-0.276 3.094-0.404 4.654-0.381 1.271 0.017 2.523 0.32 3.663 0.885 2.68 1.421 4.06 4.589 6.603 6.181 1.2 0.615 2.437 1.158 3.703 1.624 0.634 0.239 1.214 0.603 1.705 1.071 0.491 0.467 0.883 1.028 1.154 1.65 0.207 0.794 0.263 1.621 0.162 2.436 0.037 0.623-0.166 1.237-0.568 1.714-0.476 0.326-1.051 0.472-1.625 0.414-1.916 0-19.256-2.818-25.745-3.996-0.341-0.057-3.842 0.723-2.51-3.549 0.473-1.566 1.099-3.081 1.868-4.524 1.194-2.493 4.524-3.167 6.936-3.525z",
    fill: "#25233a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m239.82 275.91-3.306-1.023 16.877-53.977 3.297 1.016z",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m239.82 275.91-3.306-1.023 16.877-53.977 3.297 1.016z",
    fill: "url(#paint24_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m245.36 220.15-1.243 4.166 20.312 2.745 0.569-3.622z",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m227.79 277.54 0.512 4.312 19.736-5.555-0.918-3.557z",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m245.36 220.15-1.243 4.166 20.312 2.745 0.569-3.622z",
    fill: "url(#paint25_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m227.79 277.54 0.512 4.312 19.736-5.555-0.918-3.557z",
    fill: "url(#paint26_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248 246.6c1.619 0 2.932-1.313 2.932-2.932s-1.313-2.932-2.932-2.932-2.932 1.313-2.932 2.932 1.313 2.932 2.932 2.932z",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248.43 246.6c1.619 0 2.932-1.313 2.932-2.932s-1.313-2.932-2.932-2.932c-1.62 0-2.932 1.313-2.932 2.932s1.312 2.932 2.932 2.932z",
    fill: "url(#paint27_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m279.38 93.326-4.475 2.3797-0.642 4.5563 5.117-2.7452z",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m279.38 93.326-4.475 2.3797-0.642 4.5563 5.117-2.7452z",
    fill: "url(#paint28_linear_1_2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "hat"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m306.27 13.888c0 2.1848-0.333 4.5401-2.022 6.14-1.535 1.4538-3.866 1.998-6.083 2.3391-11.819 1.7943-23.899-0.34-34.388-6.075-1.786-0.999-3.719-2.6802-2.988-4.4345 0.226-0.4767 0.577-0.8836 1.015-1.1776 0.525-0.3502 1.083-0.6494 1.665-0.89339 4.873-2.1928 9.795-4.3938 14.765-6.4567 2.738-1.2249 5.592-2.1718 8.52-2.8263 4.71-0.92587 11.76-0.73095 15.788 2.0142 2.672 1.8192 3.427 5.7908 3.639 9.0476 0.065 0.8365 0.081 1.6324 0.089 2.3227z",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m306.18 11.565c-0.119 1.6103-0.803 3.1267-1.933 4.2801-1.535 1.4619-3.866 2.006-6.083 2.3471-11.82 1.7912-23.9-0.3458-34.388-6.0831-0.713-0.3944-1.376-0.8744-1.973-1.4294 0.525-0.3502 1.083-0.6494 1.665-0.89339 4.873-2.1928 9.795-4.3938 14.765-6.4567 2.738-1.2249 5.592-2.1718 8.52-2.8263 4.71-0.92587 11.76-0.73095 15.788 2.0142 2.672 1.8192 3.427 5.7908 3.639 9.0476z",
    fill: "url(#paint29_linear_1_2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "right-wheel"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m328.45 304.91c-12.354-1e-3 -24.43-3.667-34.7-10.532-10.271-6.865-18.274-16.621-22.999-28.036-4.725-11.414-5.959-23.973-3.546-36.089 2.414-12.115 8.366-23.243 17.104-31.976 8.738-8.732 19.87-14.677 31.987-17.082 12.117-2.406 24.676-1.164 36.087 3.568 11.411 4.733 21.162 12.743 28.021 23.018 6.858 10.274 10.516 22.353 10.509 34.706-0.03 16.554-6.622 32.42-18.331 44.121s-27.579 18.283-44.132 18.302zm0-116.81c-10.75 0-21.258 3.188-30.197 9.159-8.938 5.972-15.906 14.459-20.021 24.39s-5.193 20.859-3.099 31.402c2.095 10.544 7.269 20.23 14.868 27.833 7.599 7.604 17.281 12.783 27.824 14.885 10.542 2.101 21.471 1.029 31.404-3.081 9.933-4.109 18.425-11.071 24.402-20.006s9.17-19.441 9.177-30.191c0-14.422-5.725-28.254-15.918-38.457-10.192-10.203-24.019-15.943-38.44-15.958z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 345.46,
    x2: 304.46,
    y1: 192.6,
    y2: 291.6,
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 279.3,
    x2: 370.3,
    y1: 211.01,
    y2: 278.01,
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325.72,
    cy: 244.41,
    r: 7,
    fill: "#040404"
  })), /*#__PURE__*/React.createElement("g", {
    id: "left-wheel"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m108.02 298.3c-12.51 0-24.739-3.71-35.14-10.66-10.402-6.95-18.509-16.829-23.296-28.387-4.7873-11.557-6.0399-24.275-3.5993-36.545 2.4405-12.269 8.4647-23.54 17.31-32.385 8.8459-8.846 20.116-14.87 32.386-17.311s24.988-1.188 36.545 3.599c11.558 4.788 21.437 12.895 28.387 23.296 6.95 10.402 10.66 22.631 10.66 35.141-0.026 16.768-6.698 32.841-18.555 44.697-11.856 11.857-27.929 18.529-44.697 18.555zm0-119.01c-11.029 0-21.811 3.271-30.981 9.398-9.1704 6.128-16.318 14.838-20.538 25.027-4.2203 10.19-5.3242 21.403-3.1719 32.22s7.4641 20.753 15.264 28.552c7.7995 7.798 17.736 13.108 28.554 15.259 10.818 2.151 22.03 1.045 32.219-3.176 10.19-4.222 18.898-11.371 25.025-20.542 6.126-9.172 9.395-19.954 9.393-30.983-0.017-14.783-5.898-28.956-16.352-39.409-10.454-10.452-24.628-16.331-39.411-16.346z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.49,
    x2: 96.488,
    y1: 182.11,
    y2: 288.11,
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 236,
    r: 7,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56.188,
    x2: 162.19,
    y1: 214.54,
    y2: 257.54,
    stroke: "#000"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2",
    x1: 260.62,
    x2: 337.02,
    y1: 120.27,
    y2: 120.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFD4D1",
    offset: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2EAC9",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_2",
    x1: 311.24,
    x2: 273.43,
    y1: 111.09,
    y2: 134.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8,
    offset: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_2",
    x1: 4266.4,
    x2: 4126.3,
    y1: 3494.1,
    y2: 3490.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8,
    offset: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_2",
    x1: 11599,
    x2: 10695,
    y1: 9422.1,
    y2: 13530,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8,
    offset: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_2",
    x1: 292.57,
    x2: 338.89,
    y1: 216.91,
    y2: 211.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.84,
    offset: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_2",
    x1: 2379.6,
    x2: 3968.1,
    y1: 25490,
    y2: 25815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFD4D1",
    offset: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2EAC9",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_2",
    x1: 32559,
    x2: 33257,
    y1: 18833,
    y2: 20480,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8,
    offset: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_2",
    x1: 5018.6,
    x2: 4822.9,
    y1: 7702.1,
    y2: 7705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8,
    offset: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_2",
    x1: 5141,
    x2: 4935.9,
    y1: 5969.5,
    y2: 5990.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.84,
    offset: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1_2",
    x1: 3376.6,
    x2: 3162.9,
    y1: 6136.2,
    y2: 6150.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.84,
    offset: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1_2",
    x1: 4751.6,
    x2: 4946.2,
    y1: 25623,
    y2: 25632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8,
    offset: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1_2",
    x1: 30882,
    x2: 30921,
    y1: 7069.2,
    y2: 7539.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8,
    offset: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1_2",
    x1: 11855,
    x2: 20842,
    y1: 19295,
    y2: 21268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8,
    offset: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1_2",
    x1: 12631,
    x2: 14476,
    y1: 4206.4,
    y2: 4206.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFD4D1",
    offset: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2EAC9",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1_2",
    x1: 16520,
    x2: 30600,
    y1: 15345,
    y2: 6556.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8,
    offset: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1_2",
    x1: 3947.5,
    x2: 3397.4,
    y1: 3864.2,
    y2: 3823.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.84,
    offset: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1_2",
    x1: 7671,
    x2: 10282,
    y1: 4578.4,
    y2: 4665.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8,
    offset: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1_2",
    x1: 300.63,
    x2: 357.57,
    y1: 135.05,
    y2: 112.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.84,
    offset: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1_2",
    x1: 24918,
    x2: 32979,
    y1: 10218,
    y2: 10218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFD4D1",
    offset: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2EAC9",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1_2",
    x1: 4467.6,
    x2: 4283.2,
    y1: 1488.8,
    y2: 1534.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8,
    offset: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1_2",
    x1: 7100.1,
    x2: 7098.8,
    y1: 1663.8,
    y2: 1928.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8,
    offset: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1_2",
    x1: 14820,
    x2: 16448,
    y1: 15636,
    y2: 15000,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFD4D1",
    offset: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2EAC9",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1_2",
    x1: 673.79,
    x2: 677.12,
    y1: 688.14,
    y2: 688.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.84,
    offset: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1_2",
    x1: 4497,
    x2: 4269.2,
    y1: 3048.8,
    y2: 2949.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.84,
    offset: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1_2",
    x1: 6005.7,
    x2: 6247.6,
    y1: 16958,
    y2: 16983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8,
    offset: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1_2",
    x1: 6556.6,
    x2: 6553,
    y1: 2070.2,
    y2: 2160.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8,
    offset: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1_2",
    x1: 5864.4,
    x2: 5880.8,
    y1: 3304.6,
    y2: 3447.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8,
    offset: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1_2",
    x1: 1947.2,
    x2: 1989.5,
    y1: 2000,
    y2: 2000,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8,
    offset: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1_2",
    x1: 1973.4,
    x2: 1929.9,
    y1: 968.08,
    y2: 901.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8,
    offset: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1_2",
    x1: 15204,
    x2: 15265,
    y1: 837.58,
    y2: 1628.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8,
    offset: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBikerOptimized, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/biker-optimized.1372db19.svg";
export { ForwardRef as ReactComponent };